import { Button, Col, Divider, Flex, Row, Image, Space, message } from "antd";
import Layout, { Content, Footer, Header } from "antd/es/layout/layout";
import Title from "antd/es/typography/Title";
import { wrap } from "module";

import React, { Component } from "react";

const headerStyle: React.CSSProperties = {
  textAlign: "center",
  color: "#fff",
  minHeight: 150,
  paddingInline: 48,
  lineHeight: "150px",
  backgroundColor: "transparent",
};

const contentStyle: React.CSSProperties = {
  textAlign: "center",
  minHeight: 120,
  lineHeight: "120px",
  overflowY: "auto", // 启用垂直滚动
  color: "#fff",
  backgroundColor: "transparent",
};

const footerStyle: React.CSSProperties = {
  textAlign: "center",
  color: "#fff",
  backgroundColor: "transparent",
};

const layoutStyle = {
  borderRadius: 0,
  overflow: "hidden",
  width: "100vw",
  height: "100vh",
  backgroundImage: "linear-gradient(55deg, #FF69B4, #FFB6C1)",
};

const row = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const headerTitle = {
  color: "#fff",
};

const downloadButton = {
  backgroundColor: "#FF0080",
  color: "#fff",
  width: "150px",
  height: "40px",
};

const imageContainer = {
  width: "200px",
  // height: "355px", // 高度自动根据宽度适配
  // backgroundColor: "#FF0080",
  backgroundColor: "transparent",
};

const footerTitle = {
  color: "#f5f5f5",
};

const IOS_APP_STORE_LINK = ""; // 为空表示未上线
const ANDROID_PLAY_STORE_LINK = ""; // 为空表示未上线
const ANDROID_APK_LINK = "https://img.miaouu.cn/img/app-release.apk"; // 手机端不允许使用腾讯云默认域名加载APK文件，这里如果以后无法下载了，可能是https证书过期了，要及时续期一下

/// COS的https证书目前只给APK官网文件下载使用，目的是保证公网审核能正常下载，因为有过期风险，所以先不给其他COS资源文件使用https功能

class Home extends Component {
  state = {};

  isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
  isAndroid = () => /Android/i.test(navigator.userAgent);
  isPC = () => !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  handleIOSDownload = () => {
    if (this.isAndroid()) {
      message.info("请在安卓设备访问此页面以下载应用。");
      return;
    }
    if (!IOS_APP_STORE_LINK) {
      message.info("暂未发布上线，敬请期待");
      return;
    }
    if (this.isPC()) {
      message.info("请在手机端访问此页面以下载应用。");
      return;
    }
    window.location.href = IOS_APP_STORE_LINK;
  };

  handleAndroidDownload = () => {
    if (this.isIOS()) {
      message.info("请在安卓设备访问此页面以下载应用。");
      return;
    }
    if (!ANDROID_PLAY_STORE_LINK && !ANDROID_APK_LINK) {
      message.info("暂未发布上线，敬请期待");
      return;
    }
    if (!ANDROID_PLAY_STORE_LINK && ANDROID_APK_LINK) {
      // 直接下载apk
      window.location.href = ANDROID_APK_LINK;
      return;
    }
    // 有商店地址
    if (this.isPC()) {
      message.info("请在手机端访问此页面以下载应用。");
      return;
    }
    // 手机端直接跳转商店
    window.location.href = ANDROID_PLAY_STORE_LINK;
  };

  render() {
    return (
      <Layout style={layoutStyle}>
        <Layout style={headerStyle}>
          <Flex justify={"space-between"} align={"middle"}>
            <Row style={row}>
              <Title level={1} style={headerTitle}>
                碰搭
              </Title>
              <Divider type="vertical" />
              <Title level={4} style={headerTitle}>
                遇见同频的你
              </Title>
            </Row>
            <Col span={3}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                <div style={{ height: 10 }}></div>
                <Button
                  type="primary"
                  style={downloadButton}
                  onClick={this.handleIOSDownload}
                >
                  IOS 下载安装
                </Button>
                <Button
                  type="primary"
                  style={downloadButton}
                  onClick={this.handleAndroidDownload}
                >
                  安卓 下载安装
                </Button>
              </div>
            </Col>
          </Flex>
        </Layout>
        <Content style={contentStyle}>
          <Space
            wrap={true}
            align="center"
            size={"large"}
            style={{ display: "flex", justifyContent: "center", gap: "20px" }}
          >
            <div style={imageContainer}>
              <Image
                preview={false}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                src="https://banliao-1252033888.cos.ap-beijing.myqcloud.com/img%2Fad_04_375_812.png"
              />
            </div>
            <div style={imageContainer}>
              <Image
                preview={false}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                src="https://banliao-1252033888.cos.ap-beijing.myqcloud.com/img%2Fad_05_375_812.png"
              />
            </div>
            <div style={imageContainer}>
              <Image
                preview={false}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                src="https://banliao-1252033888.cos.ap-beijing.myqcloud.com/img%2Fad_02_375_812.png"
              />
            </div>
            <div style={imageContainer}>
              <Image
                preview={false}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                src="https://banliao-1252033888.cos.ap-beijing.myqcloud.com/img%2Fad_375_812_03.png"
              />
            </div>
          </Space>
        </Content>
        <Footer style={footerStyle}>
          <a style={footerTitle}>
            Copyright © 2025 常州码动空间网络科技有限公司. All rights reserved.
          </a>
          <div>
            <a
              style={footerTitle}
              href="https://docs.qq.com/doc/DY1FIQ3JjdUN1Yk5j"
            >
              隐私政策
            </a>
            <span> | </span>
            <a
              style={footerTitle}
              href="https://docs.qq.com/doc/DY2dWZmRqek9nR013"
            >
              服务协议
            </a>
          </div>
          <div>
            <a
              style={footerTitle}
              href="https://banliao-1252033888.cos.ap-beijing.myqcloud.com/img%2Fwebsite_company.jpg"
              id="beian"
              target="_blank"
              rel="noreferrer"
            >
              营业执照
            </a>
            <span> | </span>
            <a
              style={footerTitle}
              href="https://beian.miit.gov.cn"
              id="beian"
              target="_blank"
              rel="noreferrer"
            >
              苏ICP备2025165496号-3
            </a>
            <span> | </span>
            <a
              style={footerTitle}
              href="https://tsm.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%E8%8B%8FB2-20250926&type=xuke"
              id="beian"
              target="_blank"
              rel="noreferrer"
            >
              增值电信业务经营许可证: 苏B2-20250926
            </a>
            <span> | </span>
            <a
              style={footerTitle}
              href="https://whsc.mr.mct.gov.cn/qrcode/networkInfo?id=MmNhYzM3OTgwZGJiNDE0MmFkZjQ4NmJkYTQ4MTgwMDA="
              id="beian"
              target="_blank"
              rel="noreferrer"
            >
              网络文化经营许可: 苏网文〔2025〕1046-140号
            </a>
          </div>
          <div>
            <p>
              <img
                src="https://beian.mps.gov.cn/favicon.ico"
                width={14}
                height={14}
                alt="苏公网安备32040202000997号"
              />
              <a
                style={footerTitle}
                href="https://beian.mps.gov.cn/#/query/webSearch?code=32040202000997"
                rel="noreferrer"
                target="_blank"
              >
                苏公网安备32040202000997号
              </a>
            </p>

            <a style={footerTitle} href="mailto:chatuu@163.com">
              联系&举报邮箱: chatuu@163.com
            </a>
          </div>
        </Footer>
      </Layout>
    );
  }
}

export default Home;
